import { Banner, Button, FlexBox, Tooltip } from '@dixa/lib-shared-habla';

import { Toolbar } from './components/toolbar';
import { ViewMode } from './hooks/useBulletinEditor';
import styles from './styles.module.scss';

type HeaderProps = {
  /** Function called when the discard changes button is clicked */
  discardChanges: () => void;
  /** Function called when "Back" is pressed */
  goBackToMessengerSettings: () => void;
  /** Flag indicating if bulletin has been edited */
  hasChanges: boolean;
  /** Flag indicating if the bulletin is currently active/published */
  isActive: boolean;
  /** Flag indicating if the bulleting is currently updating */
  isUpdating: boolean;
  /** Function called when publish / save button is pressed */
  onSaveChanges: () => void;
  /** Current title */
  title: string;
  /** Current view mode */
  viewMode: ViewMode;
  /** Function that gets called when an image insert is needed. */
  openFileBrowser: () => void;
};

/** Renders the headers section of the bulletin board editor */
export function Header({
  discardChanges,
  goBackToMessengerSettings,
  hasChanges,
  isActive,
  isUpdating,
  onSaveChanges,
  title,
  viewMode,
  openFileBrowser,
}: HeaderProps): JSX.Element {
  const cantEnable = title.length === 0;

  return (
    <div className={styles.header}>
      <FlexBox justifySelf="start" alignItems="center">
        <Button
          variant="tertiary"
          icon="angle-left"
          onClick={goBackToMessengerSettings}
        >
          Back
        </Button>

        {hasChanges && (
          <span className={styles.unpublishedChanges}>Unpublished changes</span>
        )}
      </FlexBox>

      <FlexBox justifySelf="center">
        {viewMode === 'saved' ? (
          <Banner
            description={
              <span>You’re currently viewing the Published version</span>
            }
            variant="announcement"
          />
        ) : (
          <Toolbar openFileBrowser={openFileBrowser} disabled={isUpdating} />
        )}
      </FlexBox>

      <FlexBox justifySelf="end" alignItems="center">
        {hasChanges && (
          <Button
            disabled={isUpdating}
            variant="secondary"
            onClick={discardChanges}
          >
            Discard changes
          </Button>
        )}

        <Tooltip
          disabled={!cantEnable}
          content="Bulletin must have a title before publishing."
        >
          <div>
            <Button
              disabled={!hasChanges || isUpdating || cantEnable}
              className={styles.saveButton}
              variant="primary"
              onClick={onSaveChanges}
            >
              {isActive ? 'Publish' : 'Save changes'}
            </Button>
          </div>
        </Tooltip>
      </FlexBox>
    </div>
  );
}
